// Section detail cards container, ported from sections/sub_items.coffee SubItemsView + the erb
// #mn-section-cards-template: the "Expand all"/"Collapse all" strip renders only when there is
// more than one section (D3), and its label flips once every card is open.
//
// Controlled, like every other sub-items list: which sections are open lives with the block,
// which holds them as the cb report param. A section card always expands -- the coffee container
// forced it on whatever the question declared.

import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { batchElementId } from '@aytm/app/stats/page/components/lib/utils'
import { pressable } from '@aytm/app/stats/components/lib/pressable'

import ItemsList from '@aytm/app/stats/page/question-views/components/items-list/ItemsList'
import { sectionPosition } from '@aytm/app/stats/page/question-views/mn/lib/report-params'
import {
  SectionCardBody,
  SectionCardHeader
} from '@aytm/app/stats/page/question-views/mn/components/sections-section/section-cards/SectionCard'

import styles from '@aytm/app/stats/page/question-views/mn/components/sections-section/section-cards/styles/SectionCards.module.scss'

const SectionCards = ({
  sections = [],
  answer,
  image,
  questionId,
  priceTemplate,
  unCollapsedSections = [],
  onSectionCardToggle,
  onSectionCardsToggleAll
}) => {
  const allUnCollapsed = sections.length === unCollapsedSections.length
  const questionTotal = answer?.total || 0

  // a missing per-section slice means "still loading" only while the whole answer is
  const sectionAnswer = section =>
    answer?.[`sq${section.position}`] ?? ('loading' === answer ? 'loading' : { total: 0 })

  return (
    <>
      {1 < sections.length ? (
        <div className={styles.toggleRow}>
          <span className={styles.toggleAll} {...pressable(() => onSectionCardsToggleAll(allUnCollapsed))}>
            {allUnCollapsed ? 'Collapse all' : 'Expand all'}
          </span>
        </div>
      ) : null}

      <ItemsList
        items={sections}
        itemKey={sectionPosition}
        itemId={section => batchElementId(questionId, section.position)}
        openKeys={unCollapsedSections}
        renderHeader={(section, { collapsed }) => (
          <SectionCardHeader section={section} image={image} collapsed={collapsed} />
        )}
        renderBody={section => (
          <SectionCardBody
            section={section}
            answer={sectionAnswer(section)}
            questionId={questionId}
            questionTotal={questionTotal}
            priceTemplate={priceTemplate}
          />
        )}
        onToggle={onSectionCardToggle}
      />
    </>
  )
}

SectionCards.propTypes = {
  sections: PropTypes.array,
  answer: answerPropType,
  image: PropTypes.object,
  questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  priceTemplate: PropTypes.string,
  unCollapsedSections: PropTypes.array,
  onSectionCardToggle: PropTypes.func,
  onSectionCardsToggleAll: PropTypes.func
}

SectionCards.displayName = 'SectionCards'

export default SectionCards
